export default "__VITE_ASSET__BDUNwKXt__"